import { Injectable } from '@angular/core';
import { JoiningLetter } from '../model';
import { BaseService } from '../../shared/baseService';
@Injectable({
    providedIn: 'root'
})

export class JoiningLettersService extends BaseService<JoiningLetter> {
  
    constructor() {
        super('JoiningLetter');
    }
}
